module.exports = __webpack_public_path__ + "static/media/XButtonHollow.3dc5f436.svg";